import { Constant } from '@shared/constants/index'

export const SETTING_MANAGE_TYPE = Object.freeze(
  new Constant({
    PaperSetting: {
      label: '论文设置',
      value: 29001,
      name: 'PaperSetting',
    },
  }),
)

